export function filterDirectOrderProducts<T extends { siblings?: T[] }>(
  products: T[],
  isDirectOrder: (product: T) => boolean,
) {
  return products
    .filter((product) => !isDirectOrder(product))
    .map((product) => {
      const siblings = product.siblings?.filter(
        (sibling) => !isDirectOrder(sibling),
      )
      return siblings && siblings.length !== product.siblings?.length
        ? { ...product, siblings }
        : product
    })
}
